import { StateRepository } from '@/core/domain/states/repositories/state.repository';
import { GetStatesUseCase } from '@/core/domain/states/usecases/get-states.usecase';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StateImplRepository } from './state-impl.repository';

const getStatesUseCaseFactory = (statesRepository: StateRepository) =>
    new GetStatesUseCase(statesRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetStatesUseCase,
            useFactory: getStatesUseCaseFactory,
            deps: [StateRepository],
        },
        {
            provide: StateRepository,
            useClass: StateImplRepository,
        },
    ],
})
export class StateDataModule {}
